import {dispatch} from 'od-modules/secure_store/store';
import {
    SET_SHOPPING_CART,
    SET_PRIME_MEMBER_SELECTED,
} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')('refresh-membership-subscription');
    },
    getMethod() {
        return 'POST';
    },
    requestSuccess(response) {
        if (response !== null) {
            dispatch({type: SET_SHOPPING_CART, entry: response});
            dispatch({
                type: SET_PRIME_MEMBER_SELECTED,
                entry: {
                    isSubscriptionAdded: !!response.membershipPerksDTO,
                    isAddedInAncillaries: !!response.membershipPerksDTO,
                }, merge: true});
            Odigeo.trigger('refresh-membership-subscription:success', response);
        }
        return response;
    },

    requestError(response) {
        dispatch({type: SET_PRIME_MEMBER_SELECTED, entry: {
            fail: {
                error: true,
                message: 'RefreshMembershipSubscriptionFail',
            },
        }, merge: true});

        Odigeo.trigger('refresh-membership-subscription:fail', response);
        return null;
    },
};
